import Vue from 'vue'
import Router from 'vue-router'
import VueCookie from 'vue-cookie'
import Home from '@/components/pages/Home'
import Activities from '@/components/pages/Activities'
import CalendarPage from '@/components/pages/Calendar'
import AccountPage from '@/components/pages/Account'
import Login from '@/components/pages/auth/Login'
import Register from '@/components/pages/auth/Register'
import ResetPassword from '@/components/pages/auth/ResetPassword'
import ForgotPassword from '@/components/pages/auth/ForgotPassword'

import Stats from '@/components/pages/admin/stats/Stats'
import axios from 'axios'
Vue.use(Router)
Vue.prototype.$axios = axios
Vue.use(VueCookie)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/activities/',
      name: 'Activities',
      component: Activities
    },
    {
      path: '/calendar/',
      name: 'Calendar',
      component: CalendarPage
    },
    {
      path: '/account/',
      name: 'Account',
      component: AccountPage
    },
    {
      path: '/login/',
      name: 'Login',
      component: Login
    },
    {
      path: '/register/',
      name: 'Register',
      component: Register
    },
    {
      path: '/resetpassword/:key',
      name: 'ResetPassword',
      component: ResetPassword
    },
    {
      path: '/password/forgot',
      name: 'ForgotPassword',
      component: ForgotPassword
    },
    {
      path: '/admin/stats',
      name: 'Stats',
      component: Stats
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js